import { LayerProps } from 'shared/map-exports';
import { SOURCE_LAYER, FRP_COLOR_STOPS } from './NgfsDetectionsLayer.constants';

const interpolationStops = FRP_COLOR_STOPS.flatMap(([frp, color]) => [
  frp,
  color,
]);

export const getLineStyle = (): LayerProps => {
  // Clamp negatives to 0; the interpolation holds the endpoint color for frp
  // beyond the top breakpoint, so extreme detections stay magenta.
  const frp = ['max', 0, ['to-number', ['get', 'frp']]];

  return {
    type: 'line',
    'source-layer': SOURCE_LAYER,
    paint: {
      'line-color': ['interpolate', ['linear'], frp, ...interpolationStops],
      'line-width': 2,
    },
  };
};

// Transparent interactive fill layer - clicks anywhere inside the polygon are detected,
// not just on the visible outline.
export const getInteractiveFillStyle = (): LayerProps => ({
  type: 'fill',
  'source-layer': SOURCE_LAYER,
  paint: {
    'fill-color': '#000000',
    'fill-opacity': 0,
  },
});
